"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserPermissions {
}
exports.UserPermissions = UserPermissions;
//# sourceMappingURL=UserPermissions.js.map